import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'litmus-header',
    templateUrl: './litmus-header.component.html',
    styleUrls: ['./litmus-header.component.scss'],
    standalone: false
})
export class LitmusHeaderComponent implements OnChanges {
  @Input() text:string = "";
  @Input() type:string='header';
  @Input() required:any = false;
  isRequired:boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['required']){
      this.isRequired = (this.required == true || this.required == 'true')?true:false
    }
  }
}
